// Normaliza texto para comparaciones insensibles a mayúsculas y acentos (es-AR).
export const normalizeText = (value: string): string =>
  value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
